import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component, Fragment } from 'react';
import { List } from 'immutable';
import moment from 'moment';
import { fetchMessageHistory } from '../../apis/discussions';
import { UserMessageGroup } from './UserMessageGroup';
export var MessageHistory = /*#__PURE__*/function (_Component) {
  _inherits(MessageHistory, _Component);

  var _super = _createSuper(MessageHistory);

  function MessageHistory() {
    var _this;

    _classCallCheck(this, MessageHistory);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      versions: null,
      index: null
    };
    return _this;
  }

  _createClass(MessageHistory, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      fetchMessageHistory({
        discussionId: this.props.discussion.id,
        id: this.props.message.id
      }).then(function (response) {
        var versions = response.messages.reverse();
        var index = versions.findIndex(function (m) {
          return m.versionId === _this2.props.message.versionId;
        });

        _this2.setState({
          versions: versions,
          index: index !== -1 ? index : versions.length - 1
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      if (this.state.versions) {
        var currentVersion = this.state.versions[this.state.index];
        return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: "message-versions-controls"
        }, /*#__PURE__*/React.createElement("div", {
          className: "timestamp"
        }, "Changed on", ' ', moment(currentVersion.updatedAt).format(this.props.timeFormat)), /*#__PURE__*/React.createElement("div", {
          className: "page-info"
        }, this.state.index + 1, " of ", this.state.versions.length), /*#__PURE__*/React.createElement("div", {
          className: "btn-group"
        }, /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "btn btn-sm btn-inverse",
          disabled: this.state.index <= 0,
          onClick: function onClick() {
            return _this3.setState(function (state) {
              return {
                index: state.index - 1
              };
            });
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-fw fa-caret-left"
        })), /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "btn btn-sm btn-inverse",
          disabled: this.state.index >= this.state.versions.length - 1,
          onClick: function onClick() {
            return _this3.setState(function (state) {
              return {
                index: state.index + 1
              };
            });
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-fw fa-caret-right"
        })))), /*#__PURE__*/React.createElement("div", {
          className: "message-versions"
        }, /*#__PURE__*/React.createElement(UserMessageGroup, {
          discussion: this.props.discussion,
          profile: this.props.profile,
          messages: List([currentVersion])
        })));
      }

      return null;
    }
  }]);

  return MessageHistory;
}(Component);
MessageHistory.defaultProps = {
  timeFormat: 'MMMM D, YYYY h:mm A'
};